(function(){
  'use strict';

  // ---------- Toast ----------
  var toast = document.getElementById('toast');
  var toastTimer = null;
  function showToast(msg){
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ toast.classList.remove('show'); }, 2200);
  }

  // ---------- Cart count refresh ----------
  function refreshCartCount(){
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      document.querySelectorAll('[data-cart-count]').forEach(function(el){
        el.textContent = cart.item_count;
      });
    }).catch(function(){});
  }

  // ---------- Quick add (AJAX with form fallback) ----------
  document.addEventListener('submit', function(e){
    var form = e.target.closest('[data-quick-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    var old = btn.textContent;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(form.querySelector('[name=id]').value), quantity: 1 })
    }).then(function(r){
      if (!r.ok){
        return r.json().then(function(j){
          var e = new Error(j.description || 'Could not add item');
          e.handled = true;
          throw e;
        });
      }
      return r.json();
    }).then(function(item){
      btn.textContent = 'Added ✓';
      showToast((item.product_title || 'Item') + ' added to cart');
      refreshCartCount();
      if (window.__orbDrawerOpen) window.__orbDrawerOpen();
      setTimeout(function(){ btn.textContent = old; btn.disabled = false; }, 1600);
    }).catch(function(err){
      btn.disabled = false;
      btn.textContent = old;
      if (err && err.handled){
        showToast(err.message); // Shopify rejected it (e.g. sold out) - inform, don't navigate
      } else {
        form.submit(); // true network failure only - fall back to normal POST
      }
    });
  });

  // ---------- Countdown ----------
  document.querySelectorAll('[data-countdown]').forEach(function(el){
    var end = Date.parse(el.getAttribute('data-countdown'));
    if (isNaN(end)) return;
    var dd = el.querySelector('[data-dd]'), dh = el.querySelector('[data-dh]'),
        dm = el.querySelector('[data-dm]'), ds = el.querySelector('[data-ds]');
    function pad(n){ return String(n).padStart(2, '0'); }
    var timer = null;
    function tick(){
      var s = Math.floor(Math.max(0, end - Date.now()) / 1000);
      dd.textContent = pad(Math.floor(s / 86400));
      dh.textContent = pad(Math.floor(s % 86400 / 3600));
      dm.textContent = pad(Math.floor(s % 3600 / 60));
      ds.textContent = pad(s % 60);
      if (s === 0){
        var label = el.querySelector('.drop-label');
        var live = el.getAttribute('data-live-text');
        if (label && live) label.textContent = live;
        if (timer) clearInterval(timer);
      }
    }
    tick();
    timer = setInterval(tick, 1000);
  });

  // ---------- Quiz ----------
  document.querySelectorAll('.chip[data-chip]').forEach(function(chip){
    chip.addEventListener('click', function(){
      var section = chip.closest('.quiz');
      section.querySelectorAll('.chip').forEach(function(c){ c.classList.remove('on'); });
      chip.classList.add('on');
      var tpl = section.querySelector('template[data-result="' + chip.getAttribute('data-chip') + '"]');
      var out = section.querySelector('[data-quiz-out]');
      if (tpl && out) out.innerHTML = tpl.innerHTML;
    });
  });

  // ---------- Popup (session-guarded on live site, instant in editor preview) ----------
  var popup = document.getElementById('popup');
  function openPopup(){ if (popup) popup.classList.add('show'); }
  function closePopup(){ if (popup) popup.classList.remove('show'); }
  if (popup){
    document.querySelectorAll('[data-popup-close]').forEach(function(b){
      b.addEventListener('click', closePopup);
    });
    popup.addEventListener('click', function(e){ if (e.target === popup) closePopup(); });
    var seen = false;
    try { seen = sessionStorage.getItem('orb_popup') === '1'; } catch (err) {}
    if (!seen){
      setTimeout(function(){
        openPopup();
        try { sessionStorage.setItem('orb_popup', '1'); } catch (err) {}
      }, (Number(popup.getAttribute('data-delay')) || 4) * 1000);
    }
  }
  // Shopify editor: show popup when its section is selected
  document.addEventListener('shopify:section:select', function(e){
    if (e.target.querySelector && e.target.querySelector('#popup')) openPopup();
  });

  // ---------- Product gallery ----------
  document.querySelectorAll('.thumb[data-full]').forEach(function(t){
    t.addEventListener('click', function(){
      var main = document.querySelector('[data-main-img]');
      if (main) main.style.backgroundImage = 'url(' + t.getAttribute('data-full') + ')';
    });
  });

  // ---------- Reveal on scroll ----------
  if ('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
  }

  refreshCartCount();
})();

// ---------- Music player (studio: wheel, modes, touch-rotate, seek, volume) ----------
(function(){
  'use strict';
  var ALL = [];
  window.__orbPauseAll = function(except){
    ALL.forEach(function(p){
      if (p.audio !== except){ p.audio.pause(); p.setPlaying(false); }
    });
  };
  document.querySelectorAll('[data-player]').forEach(function(root){
    var fullTracks = Array.prototype.slice.call(root.querySelectorAll('[data-track]')).map(function(t){
      var limit = parseInt(t.getAttribute('data-limit'), 10);
      if (isNaN(limit)) limit = 0;
      limit = Math.max(0, Math.min(1200, limit));
      return {
        src: t.getAttribute('data-src') || '', title: t.getAttribute('data-title') || 'Untitled',
        limit: limit, loop: t.getAttribute('data-loop') === 'true',
        art: t.getAttribute('data-art') || '', mode: t.getAttribute('data-mode') || 'free',
        buyUrl: t.getAttribute('data-buy-url') || '', buyPrice: t.getAttribute('data-buy-price') || '',
        album: t.getAttribute('data-album') || '', genre: t.getAttribute('data-genre') || ''
      };
    }).filter(function(t){ return t.src; });
    if (!fullTracks.length) return;

    // ---- playlist modes: All songs -> each album -> each genre ----
    var modes = [{ label: 'All songs', list: fullTracks }];
    var seen = {};
    fullTracks.forEach(function(t){
      if (t.album && !seen['a:' + t.album]){
        seen['a:' + t.album] = 1;
        modes.push({ label: '♫ ' + t.album, list: fullTracks.filter(function(x){ return x.album === t.album; }) });
      }
    });
    fullTracks.forEach(function(t){
      if (t.genre && !seen['g:' + t.genre]){
        seen['g:' + t.genre] = 1;
        modes.push({ label: '# ' + t.genre, list: fullTracks.filter(function(x){ return x.genre === t.genre; }) });
      }
    });
    var modeIdx = 0;
    var tracks = modes[0].list;

    var audio = new Audio();
    audio.preload = 'none';
    var i = 0, playing = false;
    var titleEl = root.querySelector('[data-player-title]');
    var fillEl = root.querySelector('[data-player-fill]');
    var barEl = root.querySelector('[data-player-bar]');
    var curEl = root.querySelector('[data-player-cur]');
    var lenEl = root.querySelector('[data-player-len]');
    var playBtns = [root.querySelector('[data-play]'), root.querySelector('[data-play2]')].filter(Boolean);
    var artEl = root.querySelector('[data-player-art]');
    var dlEl = root.querySelector('[data-download]');
    var advance = root.getAttribute('data-advance') === 'true';
    var shuffle = root.getAttribute('data-shuffle') === 'true';
    var isLead = root.getAttribute('data-lead') === 'true';
    var vol = parseInt(root.getAttribute('data-volume'), 10);
    audio.volume = isNaN(vol) ? 0.8 : Math.max(0, Math.min(100, vol)) / 100;
    var volSlider = root.querySelector('[data-vol]');
    if (volSlider) volSlider.addEventListener('input', function(){ audio.volume = Number(volSlider.value) / 100; });

    function nextIndex(){
      if (shuffle && tracks.length > 1){
        var n;
        do { n = Math.floor(Math.random() * tracks.length); } while (n === i);
        return n;
      }
      return i + 1;
    }
    function fmt(s){ s = Math.max(0, Math.floor(s)); return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0'); }
    var externalTrack = null;
    function cur(){ return externalTrack || tracks[i]; }
    function effLen(){
      var t = cur();
      var d = isFinite(audio.duration) ? audio.duration : 0;
      return t.limit > 0 ? Math.min(t.limit, d || t.limit) : d;
    }
    function updateWheel(){
      var whP = root.querySelector('[data-wh-prev]'), whC = root.querySelector('[data-wh-cur]'), whN = root.querySelector('[data-wh-next]');
      if (!whC) return;
      var n = tracks.length;
      whP.textContent = n > 1 ? tracks[(i - 1 + n) % n].title : '';
      whC.textContent = tracks[i].title;
      whN.textContent = n > 1 ? tracks[(i + 1) % n].title : '';
      var d = root.querySelector('[data-wh-drum]');
      if (d){ d.classList.remove('spin'); void d.offsetWidth; d.classList.add('spin'); }
    }
    function load(n, autoplay){
      externalTrack = null;
      i = (n + tracks.length) % tracks.length;
      var t = tracks[i];
      audio.src = t.src;
      if (titleEl) titleEl.textContent = t.title;
      if (artEl){
        var fb = artEl.getAttribute('data-fallback');
        artEl.style.backgroundImage = t.art ? 'url(' + t.art + ')' : (fb ? 'url(' + fb + ')' : '');
      }
      if (dlEl){
        dlEl.hidden = false;
        dlEl.removeAttribute('download');
        if (t.mode === 'free'){
          dlEl.href = t.src; dlEl.textContent = root.getAttribute('data-dl-label') || 'Download';
          dlEl.setAttribute('download', t.title.replace(/[^\w\- ]+/g, '') + '.mp3');
        } else if (t.mode === 'buy' && t.buyUrl){
          dlEl.href = t.buyUrl; dlEl.textContent = 'Buy ' + (t.buyPrice || '');
        } else if (t.mode === 'unlock'){
          dlEl.href = '#unlock'; dlEl.textContent = 'Share to unlock';
        } else { dlEl.hidden = true; }
      }
      var sec = root.closest('section');
      if (sec){
        var ppBuy = sec.querySelector('[data-pp-buy]');
        if (ppBuy && t.buyUrl) ppBuy.href = t.buyUrl;
        var ppTitle = sec.querySelector('[data-pp-title]');
        if (ppTitle) ppTitle.textContent = t.title;
      }
      updateWheel();
      try { document.dispatchEvent(new CustomEvent('orb:trackchange', { detail: { title: t.title, src: t.src, index: i } })); } catch(err){}
      if (autoplay){ play(); } else { setPlaying(false); }
      if (lenEl) lenEl.textContent = fmt(effLen());
    }
    function setPlaying(v){
      playing = v;
      playBtns.forEach(function(b){ b.textContent = v ? '⏸' : '▶'; });
    }
    function play(){
      window.__orbPauseAll(audio);
      document.querySelectorAll('audio, video').forEach(function(m){
        if (!m.muted && !m.paused) m.pause();
      });
      audio.play().then(function(){ setPlaying(true); }).catch(function(){ setPlaying(false); });
    }
    function pause(){ audio.pause(); setPlaying(false); }

    ALL.push({ audio: audio, setPlaying: setPlaying });
    playBtns.forEach(function(b){ b.addEventListener('click', function(){ playing ? pause() : play(); }); });
    var prevBtn = root.querySelector('[data-prev]');
    if (prevBtn) prevBtn.addEventListener('click', function(){ load(i - 1, playing); });
    var nextBtn = root.querySelector('[data-next]');
    if (nextBtn) nextBtn.addEventListener('click', function(){ load(nextIndex(), playing); });

    // wheel arrows + endless touch/mouse/scroll rotation
    var whU = root.querySelector('[data-wh-up]'), whD = root.querySelector('[data-wh-down]');
    if (whU) whU.addEventListener('click', function(){ load(i - 1, playing); });
    if (whD) whD.addEventListener('click', function(){ load(i + 1, playing); });
    var drum = root.querySelector('[data-wh-drum]');
    if (drum){
      var startY = null, dragged = false;
      drum.addEventListener('pointerdown', function(e){ startY = e.clientY; dragged = false; drum.setPointerCapture(e.pointerId); });
      drum.addEventListener('pointermove', function(e){
        if (startY === null) return;
        var dy = e.clientY - startY;
        if (Math.abs(dy) > 28){ dragged = true; load(dy > 0 ? i - 1 : i + 1, playing); startY = e.clientY; }
      });
      drum.addEventListener('pointerup', function(){ startY = null; });
      drum.addEventListener('pointercancel', function(){ startY = null; });
      drum.addEventListener('wheel', function(e){
        e.preventDefault();
        load(e.deltaY > 0 ? i + 1 : i - 1, playing);
      }, { passive: false });
      drum.addEventListener('click', function(){ if (dragged){ dragged = false; return; } playing ? pause() : play(); });
    }

    // list mode selector (All songs / albums / genres)
    var modeCur = root.querySelector('[data-mode-cur]');
    function setMode(n){
      modeIdx = (n + modes.length) % modes.length;
      tracks = modes[modeIdx].list;
      if (modeCur) modeCur.textContent = modes[modeIdx].label;
      load(0, playing);
    }
    function modeStep(dir){
      if (modes.length === 1){
        var toastEl = document.getElementById('toast');
        if (toastEl){
          toastEl.textContent = 'Give tracks an Album or Genre (in the editor) to create lists';
          toastEl.classList.add('show');
          setTimeout(function(){ toastEl.classList.remove('show'); }, 2600);
        }
        return;
      }
      setMode(modeIdx + dir);
    }
    var mU = root.querySelector('[data-mode-up]'), mD = root.querySelector('[data-mode-down]');
    if (mU) mU.addEventListener('click', function(){ modeStep(-1); });
    if (mD) mD.addEventListener('click', function(){ modeStep(1); });

    // seek + timing
    if (barEl){
      barEl.addEventListener('click', function(e){
        var r = barEl.getBoundingClientRect();
        var L = effLen();
        if (L) audio.currentTime = Math.min(L - 0.05, (e.clientX - r.left) / r.width * L);
      });
    }
    audio.addEventListener('loadedmetadata', function(){ if (lenEl) lenEl.textContent = fmt(effLen()); });
    audio.addEventListener('timeupdate', function(){
      var t = cur(), L = effLen();
      if (t.limit > 0 && audio.currentTime >= t.limit){
        if (t.loop){ audio.currentTime = 0; audio.play(); }
        else if (advance){ load(nextIndex(), true); }
        else { pause(); audio.currentTime = 0; }
        return;
      }
      if (curEl) curEl.textContent = fmt(audio.currentTime);
      if (fillEl && L) fillEl.style.width = Math.min(100, audio.currentTime / L * 100) + '%';
    });
    audio.addEventListener('ended', function(){
      var t = cur();
      if (externalTrack){ setPlaying(false); return; }
      if (t.loop){ audio.currentTime = 0; audio.play(); }
      else if (advance){ load(nextIndex(), true); }
      else setPlaying(false);
    });

    // purchase + albums popups
    var ppBtn = root.querySelector('[data-pp-open]');
    var pp = root.closest('section') ? root.closest('section').querySelector('[data-pp]') : null;
    if (ppBtn && pp){
      ppBtn.addEventListener('click', function(){
        var tt = pp.querySelector('[data-pp-title]');
        if (tt) tt.textContent = tracks[i].title;
        var buy = pp.querySelector('[data-pp-buy]');
        if (buy && tracks[i].buyUrl) buy.href = tracks[i].buyUrl;
        pp.classList.add('show');
      });
      pp.addEventListener('click', function(e){ if (e.target === pp || e.target.closest('[data-pp-close]')) pp.classList.remove('show'); });
    }
    var alBtn = root.querySelector('[data-al-open]');
    var al = root.closest('section') ? root.closest('section').querySelector('[data-al]') : null;
    if (alBtn && al){
      alBtn.addEventListener('click', function(){ al.classList.add('show'); });
      al.addEventListener('click', function(e){ if (e.target === al || e.target.closest('[data-al-close]')) al.classList.remove('show'); });
    }
    if (!window.__orbGetTracks){
      window.__orbGetTracks = function(){ return fullTracks.slice(); };
      window.__orbIsPlaying = function(){ return playing; };
      window.__orbLoadIndex = function(n, autoplay){
        modeIdx = 0; tracks = modes[0].list;
        if (modeCur) modeCur.textContent = modes[0].label;
        load(n, autoplay !== false);
      };
    }
    if (!window.__orbPlayExternal){
      window.__orbPlayExternal = function(title, src){
        window.__orbPauseAll(audio);
        externalTrack = { title: title, src: src, limit: 0, loop: false, mode: 'none' };
        audio.src = src;
        if (titleEl) titleEl.textContent = title;
        if (dlEl) dlEl.hidden = true;
        play();
      };
    }

    load(shuffle ? Math.floor(Math.random() * tracks.length) : 0, false);

    if (isLead && !window.__orbLeadClaimed){
      window.__orbLeadClaimed = true;
      audio.play().then(function(){ setPlaying(true); }).catch(function(){
        var toastEl = document.getElementById('toast');
        if (toastEl){
          toastEl.textContent = '🔊 Tap anywhere to start the music';
          toastEl.classList.add('show');
          setTimeout(function(){ toastEl.classList.remove('show'); }, 4000);
        }
        var arm = function(){
          document.removeEventListener('pointerdown', arm);
          document.removeEventListener('keydown', arm);
          document.removeEventListener('touchstart', arm);
          play();
        };
        document.addEventListener('pointerdown', arm);
        document.addEventListener('keydown', arm);
        document.addEventListener('touchstart', arm);
      });
    }
  });
})();

// ---------- Share-to-unlock (free-song wheel, contact dedup, one download per song, auto-reset) ----------
(function(){
  'use strict';
  var store = {
    get: function(k){ try { return localStorage.getItem(k); } catch(e){ return null; } },
    set: function(k,v){ try { localStorage.setItem(k,v); } catch(e){} }
  };
  function codeFrom(s){
    var h = 0;
    for (var i = 0; i < s.length; i++){ h = (h * 31 + s.charCodeAt(i)) >>> 0; }
    return h.toString(36).toUpperCase().slice(0, 8);
  }
  function normContact(s){
    s = (s || '').trim().toLowerCase();
    if (!s) return '';
    return s.indexOf('@') > -1 ? s : s.replace(/[^\d+]/g, '');
  }
  function jget(k){ try { return JSON.parse(store.get(k) || '[]'); } catch(e){ return []; } }
  function jadd(k, v){ var a = jget(k); if (a.indexOf(v) === -1){ a.push(v); store.set(k, JSON.stringify(a)); return true; } return false; }
  function toast(msg){
    var t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    setTimeout(function(){ t.classList.remove('show'); }, 2600);
  }

  document.querySelectorAll('[data-unlock]').forEach(function(root){
    var mode = root.getAttribute('data-mode') || 'shares';
    var goal = parseInt(root.getAttribute('data-goal'), 10) || 10;
    var codes = (root.getAttribute('data-codes') || '').split(/\s+/).filter(Boolean).map(function(s){ return s.toLowerCase(); });
    var form = root.querySelector('.unlock-form');
    var emailInput = form && form.querySelector('input[type=email]');
    var phoneInput = form && form.querySelector('[data-phone]');
    var tagsInput = form && form.querySelector('[data-ref-tags]');
    var contactInput = root.querySelector('[data-share-contact]');
    var linkEl = root.querySelector('[data-ref-link]');

    var arrived = new URLSearchParams(location.search).get('ref');
    if (arrived){
      var b = document.createElement('div');
      b.className = 'unlock-banner';
      b.textContent = '🎧 A friend sent you — join below and you count toward their unlock.';
      root.appendChild(b);
      store.set('orb_arrived_ref', arrived);
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { referral: arrived } }) }).catch(function(){});
    }
    var savedArrived = store.get('orb_arrived_ref');
    if (form){
      form.addEventListener('submit', function(){
        var tags = ['unlock-program'];
        tags.push(savedArrived ? 'referred-by:' + savedArrived : 'referrer');
        if (emailInput && emailInput.value){
          store.set('orb_ref_email', emailInput.value);
          tags.push('ref-code:' + codeFrom(emailInput.value.toLowerCase()));
        }
        if (phoneInput && phoneInput.value){ tags.push('phone:' + phoneInput.value.replace(/[^+\d]/g, '')); }
        if (tagsInput) tagsInput.value = tags.join(',');
      });
    }
    function myCode(){
      var e = store.get('orb_ref_email');
      return e ? codeFrom(e.toLowerCase()) : '';
    }
    function myLink(){ var c = myCode(); return c ? location.origin + '/?ref=' + c : ''; }

    // ---- free-song wheel fed by the main player's track list ----
    var fsTracks = (window.__orbGetTracks ? window.__orbGetTracks() : []);
    var fsI = 0;
    var fsCur = root.querySelector('[data-fs-cur]'), fsPrev = root.querySelector('[data-fs-prev]'), fsNext = root.querySelector('[data-fs-next]');
    function claimed(src){ return jget('orb_claimed').indexOf(src) > -1; }
    function fsRender(){
      var songName = fsTracks[fsI] ? fsTracks[fsI].title : '';
      var fsHeadEl = root.querySelector('[data-fs-heading]');
      if (fsHeadEl && fsTracks.length){
        var tpl = fsHeadEl.getAttribute('data-template') || '';
        fsHeadEl.textContent = tpl.indexOf('{song}') > -1 ? tpl.replace(/\{song\}/g, songName) : (tpl || songName);
      }

      if (!fsCur || !fsTracks.length) return;
      var n = fsTracks.length;
      fsPrev.textContent = fsTracks[(fsI - 1 + n) % n].title;
      fsNext.textContent = fsTracks[(fsI + 1) % n].title;
      fsCur.textContent = fsTracks[fsI].title + (claimed(fsTracks[fsI].src) ? ' ✓ claimed' : '');
      refresh();
    }
    function fsStep(d){
      fsI = (fsI + d + fsTracks.length) % fsTracks.length;
      fsRender();
      if (window.__orbLoadIndex) window.__orbLoadIndex(fsI, window.__orbIsPlaying ? window.__orbIsPlaying() : false);
    }
    var fu = root.querySelector('[data-fs-up]'), fd = root.querySelector('[data-fs-down]');
    if (fu) fu.addEventListener('click', function(){ fsStep(-1); });
    if (fd) fd.addEventListener('click', function(){ fsStep(1); });
    var fsDrum = root.querySelector('[data-fs-wheel] .wh-drum');
    if (fsDrum){
      var fsY = null;
      fsDrum.style.touchAction = 'none';
      fsDrum.addEventListener('pointerdown', function(e){ fsY = e.clientY; fsDrum.setPointerCapture(e.pointerId); });
      fsDrum.addEventListener('pointermove', function(e){
        if (fsY === null) return;
        var dy = e.clientY - fsY;
        if (Math.abs(dy) > 28){ fsStep(dy > 0 ? -1 : 1); fsY = e.clientY; }
      });
      fsDrum.addEventListener('pointerup', function(){ fsY = null; });
      fsDrum.addEventListener('pointercancel', function(){ fsY = null; });
      fsDrum.addEventListener('wheel', function(e){ e.preventDefault(); fsStep(e.deltaY > 0 ? 1 : -1); }, { passive: false });
    }
    document.addEventListener('orb:trackchange', function(e){
      if (!fsTracks.length) return;
      fsI = Math.max(0, e.detail.index || 0);
      fsRender();
    });
    var fp = root.querySelector('[data-fs-preview]');
    if (fp) fp.addEventListener('click', function(){
      if (window.__orbLoadIndex && fsTracks.length) window.__orbLoadIndex(fsI, true);
    });

    // ---- share counting with per-person contact dedup ----
    function shareCount(){ return parseInt(store.get('orb_share_cnt') || '0', 10); }
    function bump(){
      var contact = normContact(contactInput ? contactInput.value : '');
      if (!contact){ toast('Enter your friend\'s email or phone so the share counts'); return false; }
      var key = 'orb_shared_' + (myCode() || 'anon'); // a NEW user (new email) has their own list
      if (!jadd(key, contact)){ toast('Already counted for that contact — try another friend'); return false; }
      store.set('orb_share_cnt', String(shareCount() + 1));
      if (contactInput) contactInput.value = '';
      refresh();
      return true;
    }
    root.querySelectorAll('[data-share]').forEach(function(el){
      el.addEventListener('click', function(e){
        var l = myLink();
        if (!l){ e.preventDefault(); toast('Enter your email first to get your personal link'); return; }
        if (linkEl) linkEl.value = l;
        var kind = el.getAttribute('data-share');
        var counted = bump();
        var msg = 'Free song from OneREEborn — this link counts for me: ' + l;
        if (kind === 'copy'){
          e.preventDefault();
          if (navigator.clipboard) navigator.clipboard.writeText(l);
          if (counted){ el.textContent = 'Copied ✓'; setTimeout(function(){ el.textContent = 'Copy link'; }, 1500); }
        } else if (kind === 'whatsapp'){
          if (!counted){ e.preventDefault(); return; }
          el.href = 'https://wa.me/?text=' + encodeURIComponent(msg);
        } else if (kind === 'sms'){
          if (!counted){ e.preventDefault(); return; }
          el.href = 'sms:?&body=' + encodeURIComponent(msg);
        } else if (kind === 'native'){
          e.preventDefault();
          if (counted && navigator.share) navigator.share({ text: msg, url: l }).catch(function(){});
        }
      });
    });

    var ci = root.querySelector('[data-code-input]');
    var cs = root.querySelector('[data-code-submit]');
    var codeOk = false;
    if (cs) cs.addEventListener('click', function(){
      if (ci && codes.indexOf(ci.value.trim().toLowerCase()) > -1){ codeOk = true; refresh(); }
      else { cs.textContent = 'Invalid code'; setTimeout(function(){ cs.textContent = 'Unlock with code'; }, 1500); }
    });

    function isUnlocked(){
      if (mode === 'code') return codeOk;
      if (mode === 'instant') return !!root.querySelector('[data-signed]');
      return shareCount() >= goal;
    }
    var dlBtn = root.querySelector('[data-fs-download]');
    var fsMsg = root.querySelector('[data-fs-msg]');
    function refresh(){
      var l = myLink();
      if (linkEl && l) linkEl.value = l;
      var n = shareCount();
      var cnt = root.querySelector('[data-unlock-count]');
      if (cnt) cnt.textContent = n;
      var fill = root.querySelector('[data-unlock-fill]');
      if (fill) fill.style.width = Math.min(100, n / goal * 100) + '%';
      var t = fsTracks[fsI];
      var ok = isUnlocked() && t && !claimed(t.src);
      if (dlBtn) dlBtn.disabled = !ok;
      var rewards = root.querySelector('[data-rewards]');
      if (rewards) rewards.hidden = !isUnlocked();
      if (fsMsg){
        if (t && claimed(t.src)){ fsMsg.textContent = 'Already claimed — pick a different song, or share again for more.'; fsMsg.classList.add('show'); }
        else { fsMsg.classList.remove('show'); }
      }
    }
    if (dlBtn) dlBtn.addEventListener('click', function(){
      var t = fsTracks[fsI];
      if (!t || !isUnlocked() || claimed(t.src)) return;
      jadd('orb_claimed', t.src); // one download per free-song claim
      var a = document.createElement('a');
      a.href = t.src;
      a.download = t.title.replace(/[^\w\- ]+/g, '') + '.mp3';
      document.body.appendChild(a); a.click(); a.remove();
      store.set('orb_share_cnt', '0'); // RESET — next free song needs a fresh round of shares
      codeOk = false;
      toast('Enjoy "' + t.title + '"! Counter reset — share again for another free song.');
      refresh();
    });

    fsRender();
    refresh();
  });
})();

// ---------- Bundle builder: add all items, auto-apply discount ----------
(function(){
  'use strict';
  document.querySelectorAll('[data-bundle]').forEach(function(root){
    var btn = root.querySelector('[data-bundle-add]');
    var msg = root.querySelector('[data-bundle-msg]');
    if (!btn) return;
    btn.addEventListener('click', function(){
      var ids = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-item]'))
        .map(function(el){ return parseInt(el.getAttribute('data-variant'), 10); })
        .filter(function(n){ return !isNaN(n); });
      if (!ids.length){ if (msg){ msg.textContent = 'No products in this bundle yet.'; msg.classList.add('show'); } return; }
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: ids.map(function(id){ return { id: id, quantity: 1 }; }) })
      }).then(function(r){
        if (!r.ok) return r.json().then(function(j){ throw new Error(j.description || 'Could not add bundle'); });
        var code = root.getAttribute('data-discount');
        window.location.href = code ? '/discount/' + encodeURIComponent(code) + '?redirect=/cart' : '/cart';
      }).catch(function(err){
        btn.disabled = false;
        if (msg){ msg.textContent = err.message; msg.classList.add('show'); }
      });
    });
  });
})();

// ---------- Daily bible quote rotation ----------
(function(){
  'use strict';
  document.querySelectorAll('[data-daily-quote]').forEach(function(root){
    var items = root.querySelectorAll('[data-quote-item]');
    if (!items.length) return;
    var i;
    if (root.getAttribute('data-mode') === 'random'){
      i = Math.floor(Math.random() * items.length);
    } else {
      var now = new Date();
      var day = Math.floor((now - new Date(now.getFullYear(), 0, 0)) / 86400000);
      i = day % items.length;
    }
    items[i].hidden = false;
  });
})();


// ---------- Universal exclusivity: any native audio/video starting pauses everything else ----------
(function(){
  'use strict';
  document.addEventListener('play', function(e){
    var t = e.target;
    if (!(t instanceof HTMLMediaElement) || t.muted) return;
    document.querySelectorAll('audio, video').forEach(function(m){
      if (m !== t && !m.muted && !m.paused) m.pause();
    });
    if (window.__orbPauseAll) window.__orbPauseAll(null);
  }, true);
})();

// ---------- Cart drawer ----------
(function(){
  'use strict';
  var drawer = document.querySelector('[data-drawer]');
  var bg = document.querySelector('[data-drawer-bg]');
  if (!drawer) return;
  var itemsEl = drawer.querySelector('[data-drawer-items]');
  var subEl = drawer.querySelector('[data-drawer-subtotal]');
  function money(cents){ return '$' + (cents / 100).toFixed(2); }
  function render(cart){
    if (subEl) subEl.textContent = money(cart.total_price);
    if (!itemsEl) return;
    if (!cart.items.length){ itemsEl.innerHTML = '<p class="muted">Your cart is empty — the drop is waiting.</p>'; return; }
    itemsEl.innerHTML = cart.items.map(function(it, idx){
      return '<div class="drawer-line">' +
        '<span class="cart-img" style="background-image:url(' + (it.image || '') + ')"></span>' +
        '<span class="drawer-mid"><strong>' + it.product_title + '</strong>' +
        (it.variant_title && it.variant_title !== 'Default Title' ? '<em class="muted small">' + it.variant_title + '</em>' : '') +
        '<span class="drawer-qty">' +
        '<button data-dq="' + (idx + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Decrease">−</button>' +
        '<b>' + it.quantity + '</b>' +
        '<button data-dq="' + (idx + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Increase">+</button>' +
        '<a class="cart-remove" href="#" data-dq="' + (idx + 1) + '" data-q="0">✕ Remove</a>' +
        '</span></span>' +
        '<span class="price">' + money(it.final_line_price) + '</span></div>';
    }).join('');
  }
  function refresh(){
    return fetch('/cart.js').then(function(r){ return r.json(); }).then(render).catch(function(){});
  }
  function open(){ drawer.hidden = false; bg.hidden = false; refresh(); }
  function close(){ drawer.hidden = true; bg.hidden = true; }
  window.__orbDrawerOpen = (drawer.getAttribute('data-auto') === 'true') ? open : refresh;
  document.querySelectorAll('[data-cart-open]').forEach(function(btn){
    btn.addEventListener('click', function(e){ e.preventDefault(); open(); });
  });
  drawer.addEventListener('click', function(e){
    if (e.target.closest('[data-drawer-close]')){ close(); return; }
    var q = e.target.closest('[data-dq]');
    if (q){
      e.preventDefault();
      fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(q.getAttribute('data-dq')), quantity: Number(q.getAttribute('data-q')) })
      }).then(function(r){ return r.json(); }).then(function(cart){
        render(cart);
        document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = cart.item_count; });
      }).catch(function(){});
    }
  });
  if (bg) bg.addEventListener('click', close);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
})();

// ---------- Placeable pop-ups (delay / scroll / exit / click) ----------
(function(){
  'use strict';
  document.querySelectorAll('[data-popupflex]').forEach(function(pop){
    var key = pop.getAttribute('data-key');
    var once = pop.getAttribute('data-once') === 'true';
    function seen(){ try { return once && sessionStorage.getItem(key) === '1'; } catch(e){ return false; } }
    function mark(){ try { sessionStorage.setItem(key, '1'); } catch(e){} }
    function open(){ if (seen()) return; pop.classList.add('show'); mark(); }
    function close(){ pop.classList.remove('show'); }
    pop.addEventListener('click', function(e){
      if (e.target === pop || e.target.closest('[data-pf-close]')) close();
    });
    var trig = pop.getAttribute('data-trigger');
    if (trig === 'delay'){
      setTimeout(open, (parseInt(pop.getAttribute('data-delay'), 10) || 0) * 1000);
    } else if (trig === 'scroll'){
      var pct = parseInt(pop.getAttribute('data-scroll'), 10) || 50;
      var onScroll = function(){
        var max = document.documentElement.scrollHeight - innerHeight;
        if (max > 0 && (scrollY / max) * 100 >= pct){ open(); removeEventListener('scroll', onScroll); }
      };
      addEventListener('scroll', onScroll, { passive: true });
    } else if (trig === 'exit'){
      var onExit = function(e){ if (e.clientY <= 0){ open(); document.removeEventListener('mouseleave', onExit); } };
      document.addEventListener('mouseleave', onExit);
    } else if (trig === 'click'){
      var openerId = pop.getAttribute('data-opener');
      if (openerId){
        var el = document.getElementById(openerId);
        if (el) el.addEventListener('click', function(e){ e.preventDefault(); pop.classList.add('show'); });
      }
    }
    document.querySelectorAll('[data-pf-open="' + key + '"]').forEach(function(b){
      b.addEventListener('click', function(){ pop.classList.add('show'); });
    });
    document.addEventListener('shopify:section:select', function(e){
      if (e.target.contains && e.target.contains(pop)) pop.classList.add('show');
    });
  });
})();

// ---------- Rotating media (deterministic: same slide for everyone per window) ----------
(function(){
  'use strict';
  document.querySelectorAll('[data-rotator]').forEach(function(root){
    var slides = root.querySelectorAll('[data-rot-slide]');
    if (!slides.length) return;
    var interval = Math.max(60000, parseInt(root.getAttribute('data-interval'), 10) || 3600000);
    function show(){
      var i = Math.floor(Date.now() / interval) % slides.length;
      slides.forEach(function(s, idx){ s.hidden = idx !== i; });
    }
    show();
    setInterval(show, 30000); // advances live if the window rolls over while page is open
  });
})();

// ---------- Back to top ----------
(function(){
  'use strict';
  var btn = document.querySelector('[data-top]');
  if (!btn) return;
  addEventListener('scroll', function(){ btn.hidden = scrollY < 600; }, { passive: true });
  btn.addEventListener('click', function(){ scrollTo({ top: 0, behavior: 'smooth' }); });
})();

// ---------- Music catalog: search, multi-select, bulk add, preview play ----------
(function(){
  'use strict';
  document.querySelectorAll('[data-catalog]').forEach(function(root){
    var search = root.querySelector('[data-cat-search]');
    var items = root.querySelectorAll('[data-cat-item]');
    var checks = root.querySelectorAll('[data-cat-check]');
    var all = root.querySelector('[data-cat-all]');
    var count = root.querySelector('[data-cat-count]');
    var bulk = root.querySelector('[data-cat-bulk]');
    function updateCount(){
      var n = root.querySelectorAll('[data-cat-check]:checked').length;
      if (count) count.textContent = n;
    }
    if (search) search.addEventListener('input', function(){
      var q = search.value.toLowerCase().trim();
      items.forEach(function(it){ it.hidden = q && it.getAttribute('data-title').indexOf(q) === -1; });
    });
    checks.forEach(function(c){ c.addEventListener('change', updateCount); });
    if (all) all.addEventListener('change', function(){
      checks.forEach(function(c){ if (!c.closest('[data-cat-item]').hidden) c.checked = all.checked; });
      updateCount();
    });
    if (bulk) bulk.addEventListener('click', function(){
      var ids = Array.prototype.slice.call(root.querySelectorAll('[data-cat-check]:checked'))
        .map(function(c){ return parseInt(c.getAttribute('data-variant'), 10); }).filter(function(n){ return !isNaN(n); });
      if (!ids.length) return;
      bulk.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: ids.map(function(id){ return { id: id, quantity: 1 }; }) })
      }).then(function(r){
        bulk.disabled = false;
        if (r.ok && window.__orbDrawerOpen) window.__orbDrawerOpen();
      }).catch(function(){ bulk.disabled = false; });
    });
  });
  // preview play buttons (catalog + albums) route into the main player
  document.addEventListener('click', function(e){
    var p = e.target.closest('[data-cat-play]');
    if (p && window.__orbPlayExternal){
      e.preventDefault();
      window.__orbPlayExternal(p.getAttribute('data-title'), p.getAttribute('data-src'));
    }
  });
})();

// ---------- Video player ----------
(function(){
  'use strict';
  document.querySelectorAll('[data-vplayer]').forEach(function(root){
    var main = root.querySelector('[data-vp-main]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-vp-item]'));
    var autonext = root.getAttribute('data-autonext') === 'true';
    var cur = -1;
    function ytId(u){
      var m = (u || '').match(/(?:youtu\.be\/|v=|embed\/|shorts\/)([\w-]{11})/);
      return m ? m[1] : '';
    }
    function playIdx(idx){
      if (idx < 0 || idx >= items.length) return;
      cur = idx;
      var el = items[idx];
      items.forEach(function(b, j){ b.classList.toggle('on', j === idx); });
      var yt = ytId(el.getAttribute('data-youtube'));
      var file = el.getAttribute('data-file');
      main.innerHTML = '';
      if (yt){
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube.com/embed/' + yt + '?autoplay=1&rel=0';
        f.allow = 'autoplay; encrypted-media; fullscreen';
        f.setAttribute('allowfullscreen', '');
        main.appendChild(f);
        if (window.__orbPauseAll) window.__orbPauseAll(null);
      } else if (file){
        var v = document.createElement('video');
        v.src = file; v.controls = true; v.autoplay = true; v.playsInline = true;
        if (autonext) v.addEventListener('ended', function(){ playIdx((cur + 1) % items.length); });
        main.appendChild(v); // its 'play' event triggers the universal exclusivity handler
      }
    }
    items.forEach(function(b, idx){ b.addEventListener('click', function(){ playIdx(idx); }); });
  });
})();

// ---------- Global hover thumbnails for any link tab ----------
(function(){
  'use strict';
  var tip = document.createElement('div');
  tip.className = 'thumb-tip';
  tip.hidden = true;
  document.body.appendChild(tip);
  document.addEventListener('mouseover', function(e){
    var el = e.target.closest('[data-thumb]');
    if (!el) return;
    tip.style.backgroundImage = 'url(' + el.getAttribute('data-thumb') + ')';
    tip.hidden = false;
    var r = el.getBoundingClientRect();
    tip.style.left = Math.max(8, Math.min(innerWidth - 188, r.left + r.width / 2 - 90)) + 'px';
    tip.style.top = Math.max(8, r.top - 130) + 'px';
  });
  document.addEventListener('mouseout', function(e){
    if (e.target.closest && e.target.closest('[data-thumb]')) tip.hidden = true;
  });
})();

// ---------- Overlay window: open other sites like it's one site ----------
(function(){
  'use strict';
  var ov = null;
  function openOverlay(url){
    if (!ov){
      ov = document.createElement('div');
      ov.className = 'site-overlay';
      ov.innerHTML = '<div class="so-bar"><span class="so-url"></span>' +
        '<a class="so-new" target="_blank" rel="noopener">Open in new tab ↗</a>' +
        '<button class="so-x" aria-label="Close">✕ Close</button></div><iframe></iframe>';
      document.body.appendChild(ov);
      ov.querySelector('.so-x').addEventListener('click', function(){ ov.hidden = true; ov.querySelector('iframe').src = 'about:blank'; });
    }
    ov.hidden = false;
    ov.querySelector('.so-url').textContent = url.replace(/^https?:\/\//, '').split('/')[0];
    ov.querySelector('.so-new').href = url;
    ov.querySelector('iframe').src = url;
  }
  document.addEventListener('click', function(e){
    var el = e.target.closest('[data-open]');
    if (!el) return;
    var mode = el.getAttribute('data-open');
    var url = el.getAttribute('href');
    if (!url || url === '#') return;
    if (mode === 'new'){ e.preventDefault(); window.open(url, '_blank', 'noopener'); }
    else if (mode === 'overlay'){ e.preventDefault(); openOverlay(url); }
    // 'same' falls through to normal navigation — seamless
  });
})();


// ---------- Offers wheel (tier/single/album/bundle -> heading+description+link swap) ----------
(function(){
  'use strict';
  document.querySelectorAll('[data-of-wheel]').forEach(function(wheel){
    var box = wheel.closest('.of-box') || wheel.parentElement;
    var offers = Array.prototype.slice.call(box.querySelectorAll('[data-offer]')).map(function(o){
      var h = o.querySelector('h4');
      return { name: o.getAttribute('data-name'), link: o.getAttribute('data-link') || '#', html: o.innerHTML, heading: h ? h.textContent : (o.getAttribute('data-name') || '') };
    });
    if (!offers.length) return;
    var ofI = 0;
    var oPrev = box.querySelector('[data-of-prev]'), oCur = box.querySelector('[data-of-cur]'), oNext = box.querySelector('[data-of-next]');
    var oDesc = box.querySelector('[data-of-desc]'), oGo = box.querySelector('[data-of-go]');
    var oHead = box.querySelector('[data-of-heading]');
    function render(){
      var n = offers.length;
      if (oPrev) oPrev.textContent = offers[(ofI - 1 + n) % n].name;
      if (oCur) oCur.textContent = offers[ofI].name;
      if (oNext) oNext.textContent = offers[(ofI + 1) % n].name;
      if (oDesc) oDesc.innerHTML = offers[ofI].html;
      if (oGo) oGo.href = offers[ofI].link;
      if (oHead){
        var tpl = oHead.getAttribute('data-template') || '';
        var out = tpl.replace(/\{name\}/g, offers[ofI].name).replace(/\{heading\}/g, offers[ofI].heading);
        oHead.textContent = out || offers[ofI].name;
      }

    }
    function step(d){ ofI = (ofI + d + offers.length) % offers.length; render(); }
    var ou = box.querySelector('[data-of-up]'), od = box.querySelector('[data-of-down]');
    if (ou) ou.addEventListener('click', function(){ step(-1); });
    if (od) od.addEventListener('click', function(){ step(1); });
    var drum = wheel.querySelector('.wh-drum');
    if (drum){
      var y = null;
      drum.style.touchAction = 'none';
      drum.addEventListener('pointerdown', function(e){ y = e.clientY; drum.setPointerCapture(e.pointerId); });
      drum.addEventListener('pointermove', function(e){
        if (y === null) return;
        var dy = e.clientY - y;
        if (Math.abs(dy) > 24){ step(dy > 0 ? -1 : 1); y = e.clientY; }
      });
      drum.addEventListener('pointerup', function(){ y = null; });
      drum.addEventListener('pointercancel', function(){ y = null; });
      drum.addEventListener('wheel', function(e){ e.preventDefault(); step(e.deltaY > 0 ? 1 : -1); }, { passive: false });
    }
    render();
  });
})();
